import { z } from 'zod';
import { PaginationParamsSchema, PaginationResponseSchema } from '../common/common.schemas';

export const CreateMarketplaceReviewRequestSchema = z.object({
  bookingId: z.uuid(),
  rating: z.coerce.number().int().min(1).max(5),
  comment: z.string().max(500).optional(),
});

export const MarketplaceReviewResponseSchema = z.object({
  id: z.uuid(),
  bookingId: z.uuid(),
  reviewerId: z.uuid(),
  revieweeId: z.uuid(),
  rating: z.number().int().min(1).max(5),
  comment: z.string().nullable(),
  helpfulCount: z.number().int().nonnegative(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const VendorRecentReviewSchema = z.object({
  rating: z.number().int().min(1).max(5),
  comment: z.string().nullable(),
  createdAt: z.iso.datetime(),
});

export const ListVendorReviewsQuerySchema = PaginationParamsSchema;

export const PagedVendorReviewsResponseSchema = z.object({
  items: z.array(VendorRecentReviewSchema),
  ...PaginationResponseSchema.shape,
});

export type CreateMarketplaceReviewRequest = z.infer<typeof CreateMarketplaceReviewRequestSchema>;
export type MarketplaceReviewResponse = z.infer<typeof MarketplaceReviewResponseSchema>;
export type VendorRecentReview = z.infer<typeof VendorRecentReviewSchema>;
export type ListVendorReviewsQuery = z.infer<typeof ListVendorReviewsQuerySchema>;
export type PagedVendorReviewsResponse = z.infer<typeof PagedVendorReviewsResponseSchema>;
